import { useQuery } from "@apollo/client"
import { Link } from "react-router-dom"
import { createLettermemePath, myLettermemeManagePath } from "~/common/paths"
import { useDocumentTitle } from "~/common/use-document-title"
import { viewerSettingsQuery } from "~/profile/viewer-settings-query"
import { Button } from "~/ui/button"
import { GraphqlError } from "~/ui/errors"
import { ScreenLoading } from "~/ui/screen-loading"
import Text from "~/ui/typography"

export const MyLettermemesScreen: React.FC = () => {
  const { data, error, loading } = useQuery(viewerSettingsQuery)

  useDocumentTitle("My Lettermemes")

  if (error) return <GraphqlError error={error} />
  if (loading) return <ScreenLoading />

  const ownedLettermemes = data?.viewer?.ownedLettermemes ?? []

  return (
    <div className="mx-auto max-w-3xl p-8">
      <div className="mb-8 flex items-center justify-between gap-4">
        <div>
          <Text as="h1" className="text-2xl font-bold">
            My Lettermemes
          </Text>
          <Text className="text-gray-400">Manage your newsletter preferences</Text>
        </div>
        <Link to={createLettermemePath({})}>
          <Button variant="outline">+ create new lettermeme</Button>
        </Link>
      </div>

      {ownedLettermemes.length === 0 ? (
        <Text className="text-gray-500">You don't have any Lettermemes yet.</Text>
      ) : (
        <div className="rounded-md border border-gray-700 p-6">
          {ownedLettermemes.map((lettermeme) => (
            <div
              key={lettermeme.id}
              className="flex items-center justify-between gap-4 border-b border-gray-700 py-3 last:border-b-0"
            >
              <Text className="text-gray-200">{lettermeme.name}</Text>
              <Link to={myLettermemeManagePath({ id: lettermeme.id })}>
                <Button variant="outline" size="sm" className="text-gray-200">
                  manage
                </Button>
              </Link>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
